import { ReactComponent as Icon } from "@cloudbees/honeyui-icons/svg/leave_system.svg";

export const ExternalLinkIcon = () => {
  return (
    <Icon
      className="externalLinkIcon"
      aria-hidden="true"
    />
  );
};
